import React from "react";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import { useEffect, useState } from "react";
import {
  useAddMinuteMutation,
  useGetOneMinuteQuery,
  useUpdateMinuteMutation,
  useUpdateFeedbackMutation,
  useGetSearchHistoryQuery,
  useLazyGetFeedbackQuery,
} from "../../../services/minute";
import { useLazyGetKeywordsQuery } from "../../../services/keyword";
import { Path } from "../../../Routes";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {
  Button,
  Box,
  Grid,
  Divider,
  TextField,
  ButtonGroup,
  Tooltip,
  TableCell,
  FormControl,
  Snackbar,
  Stack,
  Alert,
  LinearProgress,
  IconButton,
  CircularProgress,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useParams } from "react-router";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { SimilarCompanyIssue } from "../../../services/keyword";
import IssueActionTable from "./IssueActionTable";
import { KeyboardArrowRight, KeyboardArrowDown } from "@mui/icons-material";

type Params = {
  id?: string;
};

const Title = styled.p`
  font-size: 20px;
  color: #666666;
  font-weight: bold;
  margin-top: 1px;
  margin-bottom: 2px;
  margin-left: 20px;
  text-align: left;
`;

export const Text = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #666666;
  margin-bottom: 0px;
  margin-top: 0px;
`;

const WarningText = styled.p`
  font-size: 12px;
  color: red;
  margin-bottom: 0px;
  margin-top: 0px;
  margin-left: 600px;
`;

const SubtitleText = styled.p`
  font-size: 18px;
  color: black;
  margin-bottom: 0px;
  margin-top: 0px;
  margin-left: 0px;
`;

const TargetWordWarningText = styled.p`
  font-size: 18px;
  color: red;
  margin-bottom: 0px;
  margin-top: 0px;
  margin-left: 0px;
  width: 450px;
`;

type ErrorResponse = {
  detail_msg: string | null;
  code: number | null;
};

const TextInput = styled(TextField)`
  width: 650px;
`;

const MinuteTextInput = styled(TextField)`
  width: 800px;
`;

const ButtonDiv = styled.div`
  margin-top: 0px;
  margin-left: 600px;
  margin-bottom: 10px;
`;

const Div = styled.div`
  margin-left: 50px;
  margin-top: 25px;
`;

const MinuteDiv = styled.div`
  margin-left: 50px;
  margin-top: 0px;
  margin-right: 0px;
`;

const DateDiv = styled.div`
  margin-top: 25px;
  margin-left: 50px;
`;
const RightButtonDiv = styled.div`
  margin-top: 25px;
  margin-left: 50px;
  margin-right: 50px;
`;

const KeywordDiv = styled.div`
  margin-top: 0px;
  margin-left: 0px;
`;

const CreatePage = (): JSX.Element => {
  // ID情報
  const { id } = useParams<Params>();
  const [memoid, setMemoId] = useState(id);

  // 議事録1件取得情報
  const {
    data: getOneMinuteData,
    error: getOneMinuteError,
    refetch: getOneMinuteRefetch,
  } = useGetOneMinuteQuery(id ?? skipToken);
  const editTitle =
    getOneMinuteData === undefined ? "" : getOneMinuteData.title;
  const editMeetingDate =
    getOneMinuteData === undefined
      ? ""
      : toDateStringWithTimezone(
          new Date(getOneMinuteData.meeting_timestamp * 1000)
        ).slice(0, 10);
  const editCompanyName =
    getOneMinuteData === undefined ? "" : getOneMinuteData.company_name;
  const editContent =
    getOneMinuteData === undefined ? "" : getOneMinuteData.content;
  const editIssueActions =
    getOneMinuteData === undefined ? [] : getOneMinuteData.issue_action;

  // 議事録用
  const [title, setTitle] = useState("");
  const [meeting_date, setMeetingDate] = useState<Dayjs | null>(null);
  const [meeting_timestamp, setMeetingTimestamp] = useState<number | null>(
    null
  );
  const [company_name, setCompanyName] = useState<string | null>("");
  const [content, setContent] = useState<string | null>("");
  const [
    addMinute,
    { data: addMinuteData, error: addMinuteError, reset: addMinuteReset },
  ] = useAddMinuteMutation();
  const [
    updateMinute,
    {
      data: updateMinuteData,
      error: updateMinuteError,
      reset: updateMinuteReset,
    },
  ] = useUpdateMinuteMutation();

  // 課題アクション生成用
  const [issueActions, setIssueActions] = useState<
    { issue: string; actions: { action: string }[] }[]
  >([]);

  // キーワード生成用
  const [word, setWord] = useState("");
  const [previous_word, setPreviousWord] = useState("");
  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
  } | null>(null);
  const [selection, setSelection] = useState("");
  const [
    getKeywords,
    {
      data: getKeywordsData,
      error: getKeywordsError,
      isFetching: getKeywordsFetching,
    },
  ] = useLazyGetKeywordsQuery();
  const {
    data: getSearchHistoryData,
    error: getSearchHistoryError,
    refetch: getSearchHistoryRefetch,
  } = useGetSearchHistoryQuery(id ?? skipToken);
  const historyKeyword = getSearchHistoryData
    ? getSearchHistoryData.keywords_history
    : [];
  const historyButtons = listHistory(historyKeyword);
  const [search_id, setSearchId] = useState("");
  const [errorStatus, setErrorStatus] = useState("");

  // バリデーション用のステート
  const [titleError, setTitleError] = useState(false);
  const [company_nameError, setCompanyNameError] = useState(false);
  const [contentError, setContentError] = useState(false);

  // snackbar表示用
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [infoOpen, setInfoOpen] = React.useState(false);
  const errorHandleClose = () => {
    setErrorOpen(false);
  };
  const infoHandleClose = () => {
    setInfoOpen(false);
  };
  const [errMessage, setErrMessage] = useState<string | null>(null);
  const [infoMessage, setInfoMessage] = useState<string | null>(null);

  // キーワード評価用
  const [updateFeedback] = useUpdateFeedbackMutation();
  const tableData = getKeywordsData
    ? getKeywordsData.keyword_list.map((k) => ({
        keyword: k.keyword,
        similar_company_issues: k.similar_company_issues,
        evaluation: "No answer",
        similarity_clusters: "",
      }))
    : [];
  const [evaluation, setEvaluation] = React.useState(tableData);

  // フィードバック履歴ダウンロード用
  const [getFeedback, { data: getFeedbackData, error: getFeedbackError }] =
    useLazyGetFeedbackQuery();

  // 課題とアクション用
  const [issues, setIssues] = useState<string[]>([]);
  const [actions, setActions] = useState<string[]>([]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (addMinuteError) {
        let errMsg = "";
        if ("status" in addMinuteError) {
          // FetchBaseQueryError
          const data = addMinuteError.data as ErrorResponse;
          errMsg = data?.detail_msg ?? "メモの保存に失敗しました";
          if (errMsg.includes("max value is 300000")) {
            errMsg = "詳細内容の入力上限容量は300KBです。";
          }
        } else {
          // SerializedError
          errMsg = addMinuteError.message ?? "メモの保存に失敗しました";
        }
        setErrorOpen(true);
        setErrMessage(errMsg);
        addMinuteReset();
      }
    }
  }, [addMinuteError]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (updateMinuteError) {
        let errMsg = "";
        if ("status" in updateMinuteError) {
          // FetchBaseQueryError
          const data = updateMinuteError.data as ErrorResponse;
          errMsg = data?.detail_msg ?? "メモの更新に失敗しました";
          if (errMsg.includes("max value is 300000")) {
            errMsg = "詳細内容の入力上限容量は300KBです。";
          }
        } else {
          // SerializedError
          errMsg = updateMinuteError.message ?? "メモの更新に失敗しました";
        }
        setErrorOpen(true);
        setErrMessage(errMsg);
        updateMinuteReset();
      }
    }
  }, [updateMinuteError]);

  useEffect(() => {
    if (getFeedbackError) {
      let errMsg = "";
      if ("status" in getFeedbackError) {
        // FetchBaseQueryError
        const data = getFeedbackError.data as ErrorResponse;
        errMsg = data?.detail_msg ?? "ファイルの取得に失敗しました";
      } else {
        // SerializedError
        errMsg = getFeedbackError.message ?? "ファイルの取得に失敗しました";
      }
      setErrorOpen(true);
      setErrMessage(errMsg);
    }
  }, [getFeedbackError]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (getOneMinuteError) {
        let errMsg = "";
        if ("status" in getOneMinuteError) {
          // FetchBaseQueryError
          const data = getOneMinuteError.data as ErrorResponse;
          errMsg = data?.detail_msg ?? "データの取得に失敗しました";
        } else {
          // SerializedError
          errMsg = getOneMinuteError.message ?? "データの取得に失敗しました";
        }
        setErrorOpen(true);
        setErrMessage(errMsg);
      }
    }
  }, [getOneMinuteError]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (addMinuteData?.id !== undefined) {
        // 新規追加の直後に更新
        if (updateMinuteData?.id !== undefined) {
          const infoMsg = "メモの更新に成功しました";
          setInfoMessage(infoMsg);
          setInfoOpen(true);
          updateMinuteReset();
        }
        // 新規追加のみ
        else {
          const infoMsg = "メモの保存に成功しました";
          setInfoMessage(infoMsg);
          setInfoOpen(true);
          setMemoId(addMinuteData?.id);
          addMinuteReset();
          // 編集画面へリダイレクト
          window.location.href = "/create/" + addMinuteData?.id;
        }
      }
    }
  }, [addMinuteData]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (updateMinuteData?.id !== undefined) {
        const infoMsg = "メモの更新に成功しました";
        setInfoMessage(infoMsg);
        setInfoOpen(true);
        updateMinuteReset();
      }
    }
  }, [updateMinuteData]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (getKeywordsData?.keyword_list.length === 0) {
        const infoMsg = "キーワードは0件です";
        setInfoMessage(infoMsg);
        setInfoOpen(true);
      }
    }
  }, [getKeywordsData]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (getKeywordsData) {
        setSearchId(getKeywordsData.search_id);
        setEvaluation(tableData);
        getSearchHistoryRefetch();
      }
    }
  }, [getKeywordsData]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (getFeedbackData) {
        const link = document.createElement("a");
        link.download = "feedback_history.csv";
        link.href = getFeedbackData?.url;
        link.click();
      }
    }
  }, [getFeedbackData]);

  useEffect(() => {
    if (getKeywordsFetching === false) {
      if (
        getOneMinuteData &&
        !addMinuteData &&
        !updateMinuteData &&
        !getKeywordsData
      ) {
        // 最新データを再取得
        getOneMinuteRefetch();
        setTitle(editTitle);
        setMeetingDate(dayjs(editMeetingDate));
        setCompanyName(editCompanyName);
        setContent(editContent);
        setIssueActions(editIssueActions);
        // issuesとactionsを設定
        const issueActionData = getOneMinuteData.issue_action || [];
        const newIssues = issueActionData.map((item) => item.issue);
        const newActions = issueActionData.map((item) =>
          item.actions.map((action) => action.action).join("\n")
        );
        setIssues(newIssues);
        setActions(newActions);
      }
    }
  }, [getOneMinuteData, addMinuteData, updateMinuteData, getKeywordsData]);

  const formatCompanyInfo = (company: SimilarCompanyIssue) => {
    const formattedScore = company.company_score.toFixed(2);
    if (parseFloat(formattedScore) < 0.7) return null;
    const docUrl = `https://disclosure2.edinet-fsa.go.jp/WZEK0040.aspx?${company.doc_id}`;
    return (
      <React.Fragment>
        <Typography>
          {company.id}. <strong>{company.JSIC}</strong>（{formattedScore}）
          <a href={docUrl} target="_blank" rel="noopener noreferrer">
            {company.company_name}
          </a>
        </Typography>
        <Typography variant="body2" component="div"></Typography>
      </React.Fragment>
    );
  };

  const formatSimilarCompanyInfo = (company: SimilarCompanyIssue) => {
    const formattedScore = company.company_score.toFixed(2);
    if (parseFloat(formattedScore) < 0.7) return null;
    const docUrl = `https://disclosure2.edinet-fsa.go.jp/WZEK0040.aspx?${company.doc_id}`;
    const truncatedIssueName =
      company.issue_name.length > 50
        ? `${company.issue_name.slice(0, 50)}...`
        : company.issue_name;
    return (
      <React.Fragment>
        <Tooltip
          title={
            <div
              style={{
                backgroundColor: "#fff",
                color: "#000",
                border: "1px solid #000",
                fontSize: "12px",
              }}
            >
              {company.id}.<strong>{company.JSIC}</strong>（{formattedScore}）
              <a href={docUrl} target="_blank" rel="noopener noreferrer">
                {company.company_name}
              </a>
              <br />
              {truncatedIssueName}
            </div>
          }
          arrow
        >
          <Typography style={{ display: "inline" }}>
            {company.id}.<strong>{company.JSIC}</strong>&nbsp;
          </Typography>
        </Tooltip>
      </React.Fragment>
    );
  };

  const [showSimilarCompanyIssues, setShowSimilarCompanyIssues] =
    useState(false);

  const options = {
    // 高さ指定
    tableBodyHeight: "555px",
    tableBodyWidth: "800px",

    // 列選択のcheckboxを表示しない
    selectableRows: false as any,
    // selectableRows: 'none',
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,

    rowsPerPage: 100,
    rowsPerPageOptions: [],
    textLabels: {
      body: {
        noMatch: `表示できるデータが存在しません`,
      },
    },
  };

  const columns = [
    {
      name: "keyword",
      label: "生成された関連課題",
      options: {
        filter: true,
        customHeadRender: () => (
          <TableCell
            style={{
              height: "30px",
              width: "40%",
              borderBottom: "1px solid rgba(224, 224, 224, 1)",
            }}
          >
            生成された関連課題
          </TableCell> // ヘッダーの列幅を固定
        ),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          const similarCompanyIssues = tableMeta.rowData[1];
          const formattedCompanies = similarCompanyIssues
            ? similarCompanyIssues
                .map((company: SimilarCompanyIssue) =>
                  formatCompanyInfo(company)
                )
                .filter(Boolean)
            : [];
          const tooltipContent =
            formattedCompanies.length > 0
              ? formattedCompanies
              : "似た課題を持つ企業は見つかりませんでした";

          return (
            <th
              style={{
                width: showSimilarCompanyIssues ? "40%" : "80%",
                wordWrap: "break-word",
              }}
            >
              {showSimilarCompanyIssues ? (
                <Typography component={"span"} noWrap={false}>
                  {value}
                </Typography>
              ) : (
                <Tooltip
                  title={
                    <div
                      style={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #000",
                      }}
                    >
                      {tooltipContent}
                    </div>
                  }
                  arrow
                >
                  <Typography component={"span"} noWrap={false}>
                    {value}
                  </Typography>
                </Tooltip>
              )}
            </th>
          );
        },
      },
    },
    {
      name: "similar_company_issues",
      label: "似た課題を持つ企業",
      options: {
        display: showSimilarCompanyIssues,
        customHeadRender: () => (
          <TableCell
            style={{
              height: "30px",
              width: "40%",
              borderBottom: "1px solid rgba(224, 224, 224, 1)",
            }}
          >
            <span style={{ marginLeft: "5px" }}>似た課題を持つ企業</span>
          </TableCell>
        ),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          if (!showSimilarCompanyIssues) return null;
          const formattedCompanies = value
            ? value
                .map((company: SimilarCompanyIssue) =>
                  formatSimilarCompanyInfo(company)
                )
                .filter(Boolean)
            : [];
          return (
            <th
              style={{
                width: "100%",
                wordWrap: "break-word",
                display: "inline-block",
                whiteSpace: "pre-wrap",
              }}
            >
              {formattedCompanies.length > 0 ? (
                formattedCompanies
              ) : (
                <Typography>見つかりませんでした</Typography>
              )}
            </th>
          );
        },
      },
    },
    {
      name: "evaluation",
      label: "評価",
      options: {
        filter: true,
        sort: false,
        empty: false,
        customHeadRender: () => (
          <TableCell
            style={{
              height: "30px",
              width: "10%",
              borderBottom: "1px solid rgba(224, 224, 224, 1)",
            }}
          >
            評価
          </TableCell>
        ),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <th style={{ width: "10%" }}>
              <FormControl sx={{ width: 100 }} variant="standard">
                <Select
                  labelId="client-evaluation-label"
                  id="client-evaluation"
                  value={value}
                  onChange={(e) =>
                    handleChange(e, tableMeta.tableData, tableMeta.rowIndex)
                  }
                >
                  <MenuItem value="No answer">未選択</MenuItem>
                  <MenuItem value="good">響いた</MenuItem>
                  <MenuItem value="not good">響かなかった</MenuItem>
                </Select>
              </FormControl>
            </th>
          );
        },
      },
    },
    {
      name: "similarity_clusters",
      label: "詳細分析",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customHeadRender: () => (
          <TableCell
            style={{
              height: "30px",
              width: "10%",
              borderBottom: "1px solid rgba(224, 224, 224, 1)",
            }}
          >
            詳細分析
          </TableCell>
        ),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          const keyword = tableMeta.rowData[0];
          const company_name = getOneMinuteData?.company_name || "";
          return (
            <th style={{ width: "10%" }}>
              <Button
                sx={{ width: 100, fontSize: "10px", mb: 1 }}
                variant="contained"
                color="primary"
                onClick={() => handleClusterButtonClick(keyword, company_name)}
              >
                類似課題検索
              </Button>
              <Button
                sx={{ width: 100, fontSize: "10px" }}
                variant="contained"
                color="secondary"
                onClick={() => handleCauseButtonClick(keyword)}
              >
                なぜなぜ分析
              </Button>
            </th>
          );
        },
      },
    },
  ];

  function toDateStringWithTimezone(date: Date): string {
    const pad = function (str: string): string {
      return ("0" + str).slice(-2);
    };
    const year = date.getFullYear().toString();
    const month = pad((date.getMonth() + 1).toString());
    const day = pad(date.getDate().toString());
    return `${year}-${month}-${day}`;
  }

  function listHistory(list_keywords: string[]) {
    const historyButtons = [];
    const n = 9;
    for (let i = 0; i < list_keywords.length; i++) {
      const display_keyword =
        list_keywords[i].length < n
          ? list_keywords[i]
          : list_keywords[i].substring(0, n) + "...";
      historyButtons.push(
        <Tooltip key={i} title={list_keywords[i]}>
          <Button
            key={i}
            onClick={(e) => {
              setWord(list_keywords[i]);
              handleKeywordButtonClick(e);
            }}
          >
            {display_keyword}
          </Button>
        </Tooltip>
      );
    }
    return historyButtons;
  }

  const formValidation = (): boolean => {
    //タイトルのバリデーション
    if (!title?.trim()) {
      // 未入力と空白スペース(半角、全角)はNG.
      setTitleError(true);
      return true;
    }
    if (title !== null && title.length > 50) {
      // 51文字以上はNG.
      const errMsg = "タイトルの入力上限は50文字です。";
      setErrorOpen(true);
      setErrMessage(errMsg);
      return true;
    }
    // 商談日のバリデーション
    if (meeting_timestamp !== null && isNaN(meeting_timestamp)) {
      const errMsg = "商談日を修正してください。(YYYY/MM/DD)";
      setErrorOpen(true);
      setErrMessage(errMsg);
      return true;
    }
    // 企業名のバリデーション
    if (company_name !== null && company_name.length > 50) {
      // 51文字以上はNG.
      const errMsg = "企業名の入力上限は50文字です。";
      setErrorOpen(true);
      setErrMessage(errMsg);
      return true;
    }
    return false;
  };

  const handleIssueActionChange = (
    issueActions: { issue: string; actions: { action: string }[] }[]
  ) => {
    setIssueActions(issueActions);
  };

  useEffect(() => {
    console.log("createPage.tsxファイルで見る最新のissues:", issues);
    console.log("createPage.tsxファイルで見る最新のactions:", actions);
  }, [issues, actions]);

  const handleSubmit = () => {
    if (!formValidation()) {
      // 最新のissueとactionの内容を取得し、空の行を削除
      const cleanedIssueActions = issueActions.filter(
        (issueAction) =>
          issueAction.issue.trim() !== "" ||
          issueAction.actions.some((action) => action.action.trim() !== "")
      );
      if (memoid === undefined) {
        // 最新のissueとactionの内容を取得
        const formData = {
          title,
          meeting_timestamp,
          company_name,
          content,
          issue_action:
            cleanedIssueActions.length > 0
              ? cleanedIssueActions
              : [{ issue: "", actions: [{ action: "" }] }],
        };
        console.log("登録formData", formData); // ここで登録データを表示
        console.log("登録formData", JSON.stringify(formData));
        // 議事録登録
        addMinute(formData);
      } else {
        const formData = {
          memoid,
          title,
          meeting_timestamp,
          company_name,
          content,
          issue_action:
            cleanedIssueActions.length > 0
              ? cleanedIssueActions
              : [{ issue: "", actions: [{ action: "" }] }],
        };
        console.log("更新formData", formData); // ここで更新データを表示
        console.log("更新formData", JSON.stringify(formData));
        // 議事録更新
        updateMinute(formData);
      }
    }
  };

  const handleKeywordButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    if (e.currentTarget.ariaLabel !== null) {
      const label: string = e.currentTarget.ariaLabel;
      if (memoid !== undefined) {
        const formData = {
          word: label,
          id: memoid,
        };
        getKeywords(formData);
      }
    }
  };

  const handleWordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPreviousWord(word); // 現在のwordをprevious_wordに設定
    setWord(event.target.value);
  };

  // コンテキストメニューのハンドラーを追加
  const handleContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null
    );
  };

  // コンテキストメニューを閉じるハンドラーを追加
  const handleContextMenuClose = () => {
    setContextMenu(null);
  };

  // テキスト選択のハンドラーを追加
  const handleSelect = (e: React.SyntheticEvent<HTMLDivElement, Event>) => {
    const target = e.target as HTMLInputElement;
    const startText = target.selectionStart;
    const endText = target.selectionEnd;
    if (startText !== null && endText !== null) {
      const selectedText = target.value.substring(startText, endText);
      if (selectedText !== "") {
        setSelection(selectedText);
      }
    }
  };

  const handleWordSubmit = () => {
    // キーワード生成処理
    if (memoid !== undefined) {
      const formData = {
        word: word,
        id: memoid,
      };
      if (word !== previous_word || errorStatus !== "") {
        const fetchKeywords = async (retryCount = 0) => {
          try {
            const response = await getKeywords(formData);
            console.log("取得したデータ:", response); // ここでデータをコンソールに出力
            if (response.error) {
              const error = response.error as any;
              console.log("エラー:", response.error);
              if (error.status === "FETCH_ERROR" && retryCount < 2) {
                console.log(`再試行中... (${retryCount + 1}回目)`);
                fetchKeywords(retryCount + 1); // すぐに再試行
              } else if (error.status === "FETCH_ERROR") {
                setErrorOpen(true);
                setErrMessage("サーバータイムアウト:もう一度実行してください");
                setErrorStatus("FETCH_ERROR");
              } else {
                setErrorOpen(true);
                setErrMessage("サーバーエラー");
                setErrorStatus("SERVER_ERROR");
              }
            } else {
              getSearchHistoryRefetch();
              setErrorStatus(""); // エラーがない場合はリセット
            }
          } catch (error) {
            setErrorOpen(true);
            setErrMessage("予期せぬエラーが発生しました");
            console.log("予期せぬエラーが発生しました:", error);
            setErrorStatus("UNEXPECTED_ERROR");
          }
        };

        fetchKeywords();
      }
      setPreviousWord(word);
    }
  };

  const handleChange = (
    e: SelectChangeEvent,
    rowData: any,
    rowIndex: number
  ) => {
    // evaluationのコピーを作成
    const newEvaluation = [...evaluation];
    newEvaluation[rowIndex] = {
      ...newEvaluation[rowIndex],
      evaluation: e.target.value,
    };
    setEvaluation(newEvaluation);
    const keyword = newEvaluation[rowIndex].keyword;
    const idx = String(rowIndex);
    const feedback =
      e.target.value === "good" ? 1 : e.target.value === "not good" ? -1 : 0;

    if (memoid !== undefined) {
      const feedbackData = {
        id: memoid,
        search_id: search_id,
        idx: idx,
        keyword: keyword,
        feedback: feedback,
      };
      updateFeedback(feedbackData);
    }
  };

  const handleClusterButtonClick = (
    keyword?: string,
    company_name?: string
  ) => {
    const encodedKeyword = keyword ? encodeURIComponent(keyword) : "";
    const encodedCompanyName = company_name
      ? encodeURIComponent(company_name)
      : "";
    const url = `/clusters?keyword=${encodedKeyword}&company_name=${encodedCompanyName}`;
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.onload = () => {
        newWindow.document.title = "類似課題検索/" + (keyword || "");
      };
    }
  };

  const handleCauseButtonClick = (keyword?: string) => {
    const url = keyword
      ? `/cause?keyword=${encodeURIComponent(keyword)}`
      : "/cause";
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.onload = () => {
        newWindow.document.title = "なぜなぜ分析/" + (keyword || "");
      };
    }
  };

  const handleDownload = () => {
    if (
      memoid !== undefined &&
      meeting_date !== null &&
      company_name !== null
    ) {
      const downloadData = {
        id: memoid,
        search_id: "xxx",
        title: title,
        meeting_timestamp: meeting_date.format("YYYY/MM/DD"),
        company_name: company_name,
      };
      getFeedback(downloadData);
    }
  };

  return (
    <div style={{ whiteSpace: "pre-line" }}>
      {getKeywordsFetching && (
        <Box
          sx={{
            position: "absolute",
            top: "60%",
            right: "25%",
            zIndex: 1300, // MUIのDialogと同等のz-index
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Grid container>
        <Grid item xs={12}>
          <div>
            <Title>商談メモ詳細</Title>
          </div>
        </Grid>
      </Grid>
      <Divider variant="middle" />

      <Grid container>
        <Grid item xs={12} sm={5}>
          <Div>
            <Text>タイトル</Text>
            <Box display="flex" justifyContent="baseline" alignItems="center">
              <TextInput
                required
                type="text"
                size="small"
                value={title}
                error={titleError}
                helperText={titleError ? "タイトルは必須事項です。" : " "}
                onChange={(inputTitle) => {
                  setTitleError(false);
                  setTitle(inputTitle.target.value);
                }}
              />
            </Box>
          </Div>
        </Grid>
        <Grid item xs={12} sm={2}>
          <DateDiv>
            <Text>商談日</Text>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box display="flex" justifyContent="baseline" alignItems="center">
                <DatePicker
                  slotProps={{
                    actionBar: {
                      actions: ["clear"],
                    },
                    textField: {
                      size: "small",
                    },
                  }}
                  format="YYYY/MM/DD"
                  value={meeting_date}
                  onChange={(selectedMeetingDate) => {
                    setMeetingDate(selectedMeetingDate);
                    if (selectedMeetingDate) {
                      setMeetingTimestamp(selectedMeetingDate.unix());
                    }
                  }}
                />
              </Box>
            </LocalizationProvider>
          </DateDiv>
        </Grid>
        <Grid item xs={11} sm={4}>
          <DateDiv>
            <Text>企業名</Text>
            <Box display="flex" justifyContent="baseline" alignItems="center">
              <TextInput
                type="text"
                size="small"
                value={company_name}
                error={company_nameError}
                onChange={(inputCompanyName) => {
                  setCompanyName(inputCompanyName.target.value);
                }}
              />
            </Box>
          </DateDiv>
        </Grid>
        <Grid item xs={12} sm={1}>
          <RightButtonDiv>
            <Box display="flex" flexDirection="column" ml={2}>
              <Button
                sx={{ width: 100, fontSize: "10px", mb: 1 }}
                variant="contained"
                color="primary"
                onClick={() =>
                  handleClusterButtonClick(undefined, company_name ?? undefined)
                }
              >
                類似課題検索
              </Button>
              <Button
                sx={{ width: 100, fontSize: "10px" }}
                variant="contained"
                color="secondary"
                onClick={() => handleCauseButtonClick()}
              >
                なぜなぜ分析
              </Button>
            </Box>
          </RightButtonDiv>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        {/* 左半分 */}
        <Grid
          item
          xs={12}
          md={6}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <MinuteDiv style={{ flex: 1 }}>
            <Grid item style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", width: "100%" }}>
                <Text style={{ textAlign: "left", marginRight: "auto" }}>
                  詳細内容
                </Text>
                <WarningText style={{ textAlign: "right", marginLeft: "auto" }}>
                  一覧に戻ると編集内容が失われます。
                </WarningText>
              </div>
              <ButtonDiv style={{ alignSelf: "flex-end", marginLeft: "auto" }}>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    保存
                  </Button>
                  <Link to={Path.list}>
                    <Button variant="contained">一覧に戻る</Button>
                  </Link>
                </Stack>
              </ButtonDiv>
            </Grid>
            <MinuteTextInput
              style={{ width: "100%" }}
              onContextMenu={handleContextMenu}
              type="text"
              size="small"
              multiline
              rows={20}
              value={content}
              error={contentError}
              onChange={(inputContent) => {
                setContent(inputContent.target.value);
              }}
              onSelect={handleSelect}
            />
            {/* コンテキストメニューの表示部分を追加 */}
            {contextMenu !== null && (
              <button
                style={{
                  position: "absolute",
                  top: contextMenu.mouseY,
                  left: contextMenu.mouseX,
                  backgroundColor: "white",
                  boxShadow: "0px 0px 5px rgba(0,0,0,0.5)",
                  zIndex: 1000,
                  padding: "10px", // パディングを追加してボタンのように見せる
                  cursor: "pointer", // カーソルをポインターに変更
                  border: "none", // ボーダーをなくす
                  borderRadius: "5px", // 角を丸くする
                }}
                onClick={() => {
                  const truncatedSelection =
                    selection.length > 50
                      ? selection.substring(0, 50)
                      : selection;
                  setWord(truncatedSelection); // 選択したテキストを50文字までに切り捨てて word に設定
                  handleContextMenuClose();
                }}
              >
                キーワードにコピー
              </button>
            )}
            <Grid
              item
              style={{
                height: "25%",
                marginTop: "10px",
                position: "relative",
                zIndex: 10,
              }}
            >
              <IssueActionTable
                initialIssues={issues}
                initialActions={actions}
                memoid={memoid}
                content={content}
                onIssueActionChange={handleIssueActionChange}
              />
            </Grid>
          </MinuteDiv>
        </Grid>
        {/* 右半分 */}
        <Grid
          item
          xs={12}
          md={6}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <KeywordDiv style={{ flex: 1 }}>
            <Text>AI課題連想</Text>
            <Stack direction="row" spacing={2} alignItems="center">
              <SubtitleText>キーワード：</SubtitleText>
              {id === undefined ? (
                <TargetWordWarningText>
                  議事録保存後使用できます。
                </TargetWordWarningText>
              ) : (
                <TextField
                  value={word}
                  onChange={(
                    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                  ) => {
                    handleWordChange(e as React.ChangeEvent<HTMLInputElement>); // 型をキャスト
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      if (!word.trim() || word === previous_word) {
                        // 空の時や値が変わらない時
                        event.preventDefault(); // デフォルトの改行動作を防ぐ
                      } else {
                        event.preventDefault(); // デフォルトの改行動作を防ぐ
                        handleWordSubmit();
                      }
                    }
                  }}
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 50 }}
                  multiline
                  style={{
                    flexGrow: 1,
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                />
              )}
              <Button
                variant="contained"
                disabled={
                  !word.trim() ||
                  (word === previous_word && errorStatus === "") ||
                  id === undefined
                } // 空の時や値が変わらない時（直近がエラーではない）
                onClick={handleWordSubmit}
              >
                実行
              </Button>
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              marginTop={2}
            >
              <SubtitleText>履歴：</SubtitleText>
              <ButtonGroup size="small">{historyButtons}</ButtonGroup>
              <Tooltip title="フィードバック履歴取得">
                <span>
                  <IconButton
                    size="small"
                    disabled={id === undefined}
                    onClick={handleDownload}
                  >
                    <GetAppIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Button
                size="small"
                onClick={() =>
                  setShowSimilarCompanyIssues(!showSimilarCompanyIssues)
                }
              >
                {showSimilarCompanyIssues ? (
                  <>
                    <KeyboardArrowDown />
                    <span style={{ marginLeft: "5px" }}>
                      似た課題を持つ企業
                    </span>
                  </>
                ) : (
                  <>
                    <KeyboardArrowRight />
                    <span style={{ marginLeft: "5px" }}>
                      似た課題を持つ企業
                    </span>
                  </>
                )}
              </Button>
            </Stack>
            {getKeywordsFetching && (
              <Box sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
            )}
            <MUIDataTable
              title=""
              data={evaluation}
              columns={columns}
              options={options}
            />
          </KeywordDiv>
        </Grid>
      </Grid>

      <Snackbar
        open={errorOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={errorHandleClose}
      >
        <Alert
          onClose={errorHandleClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={infoOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={infoHandleClose}
      >
        <Alert onClose={infoHandleClose} severity="info" sx={{ width: "100%" }}>
          {infoMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreatePage;
